import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  generateSessionId(): string {
    const newSessionId = this.createSessionId();
    this.setItem('sessionId', newSessionId);
    return newSessionId;
  }

  getSessionId(): string | null {
    let session = this.getItem<string>('sessionId');
    if (!session) {
      session = this.generateSessionId();
    }
    return session;
  }

  private createSessionId(): string {
    return 'session-' + Date.now();
  }

  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    try {
      if (value) {
        return JSON.parse(value) as T;
      }
    } catch (error) {
      console.error('Error parsing session storage item:', error);
    }
    return null;
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
